import { ChangeDetectorRef, Component, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { MatSort } from '@angular/material/sort';
import { MatPaginator } from '@angular/material/paginator';
import { AlertDialog, ConfirmDialog, OpenDialog } from '../../../../../shared/dialogs/dialog';
import { MaterialPageGrid } from '../../../../../utils/material-page-grid';
import { UserModalComponent } from './user-modal/user-modal.component';
import { userRoles, roles, privileges } from '../../../../../data/admin-master-data';
import { AdminUsersService } from '../../../../../services/admin-users.service.';
import { SuperAdminService } from '../../../../../services/super-admin.service';
import { UsersService } from '../../../../../services/users.service';

@Component({
  selector: 'app-users',
  templateUrl: './users.component.html',
  styleUrls: ['./users.component.scss'],
})
export class UsersComponent implements OnInit {
  @ViewChild(MatSort) sort: MatSort;
  @ViewChild(MatPaginator) paginator: MatPaginator;

  active: boolean;
  resultsPageGrid: MaterialPageGrid;
  filterForm: FormGroup;
  gridInProgress = false;
  category: string;
  addfunc: string;
  isActive: string;
  userRoles = userRoles;
  roles = roles;
  privilegesList = privileges;
  disabledRole;
  displayedColumns: string[] = ['profilePic', 'userInfo', 'role', 'actions', 'status'];
  mobileColumns: string[] = ['mobileView'];
  constructor(
    private adminUserService: AdminUsersService,
    private usersService: UsersService,
    private fb: FormBuilder,
    private superAdminService: SuperAdminService,
    private cdRef: ChangeDetectorRef
  ) {}

  ngOnInit() {
    this.category = 'All';
    this.isActive = 'active';
    // this.initGrid();
    this.initGrid();
    this.superAdminService.emitChange.subscribe((value) => {
      if (value && value.role) {
        this.resultsPageGrid.filtersForm.get('role').setValue(value.role);
      }
      if (value && value.prive) {
        this.resultsPageGrid.filtersForm.get('privilege').setValue(value.prive);
      }
    });
    this.resultsPageGrid.filtersForm.get('privilege').valueChanges.subscribe((value) => {
      this.clearSelect('role', false);
    });
    this.resultsPageGrid.filtersForm.get('role').valueChanges.subscribe((value) => {
      this.clearSelect('privilege', false);
    });
    this.cdRef.detectChanges();
  }

  unblockUser(user) {
    user.blockInProgress = true;
    this.usersService
      .unBlockUser(user.id)
      .then((res) => {
        setTimeout(() => {
          user.blocked = !user.blocked;
          user.active = res.active;
          user.blockInProgress = false;
        }, 2000);
      })
      .catch((e) => {
        user.blockInProgress = false;
      });
  }

  async initGrid() {
    this.resultsPageGrid = new MaterialPageGrid(this.fb, 20)
      .setTableColumns(this.displayedColumns)
      .setSource(async (listQuery) => {
        try {
          this.gridInProgress = true;
          const gridData = await this.adminUserService.usersOfRolePrev(listQuery);
          this.gridInProgress = false;

          return {
            data: gridData.data || [],
            total: gridData.count || 0,
          };
        } catch (error) {
          this.gridInProgress = false;
          return { data: [], total: 0 };
        }
      })
      .setFilters({
        searchText: '',
        privilege: '',
        role: '',
      });

    // Attach sort and paginator after view init
    setTimeout(() => {
      if (this.sort) {
        this.resultsPageGrid.attachSort(this.sort);
      }
      if (this.paginator) {
        this.resultsPageGrid.attachPaginator(this.paginator);
      }
    });
  }
  refreshGrid() {
    this.resultsPageGrid.refreshData();
  }
  clearSelect(control, valueEmit = true) {
    this.resultsPageGrid.filtersForm.get(control).setValue(null, { emitEvent: valueEmit });
  }
  async userModal(user) {
    let isAdmin;
    if (user !== '') {
      user?.roles?.forEach((element) => {
        if (element === 'ROLE_ADMIN') {
          isAdmin = true;
        }
      });
    }
    try {
      await OpenDialog(UserModalComponent, { userObj: user, roles: this.roles.filter((role) => !role['disable']), isAdmin: isAdmin });
      this.resultsPageGrid.refreshData();
    } catch {
      this.roles?.forEach((element) => {
        element.selected = false;
      });
      this.roles = roles;
      isAdmin = false;
    }
  }

  async resetPassword(user) {
    user.resetPasswordInProgress = true;
    if (await ConfirmDialog(`Send Password Reset link?`, 'Confirm action', 'Send', 'Cancel')) {
      let email = user.email;
      this.adminUserService
        .resetUserPassword({ email: user.email })
        .then((data) => {
          user.resetPasswordInProgress = false;
          AlertDialog('A password reset link has been sent to ' + email, 'Password Reset', 'Ok');
        })
        .catch((e) => {
          user.resetPasswordInProgress = false;
        });
    }
  }

  async deleteUser(user) {
    let isAdmin;
    let isRM;
    if (user.roles.some((role) => role === 'ROLE_ADMIN')) {
      isAdmin = true;
    }
    if (['ROLE_RM_CALI', 'ROLE_RM_CALS', 'ROLE_RM_CALT'].some((rmRole) => user.roles.some((role) => role === rmRole))) {
      isRM = true;
    }

    if (isAdmin) {
      await AlertDialog(`${user.firstName} ${user.lastName} is an Administrator and cannot be deleted!`, 'Invalid action', 'Ok');
    } else {
      let msg;
      msg = isRM
        ? `Selected RM( ${user.firstName} ${user.lastName}) may have Associate with users and Deletion can be affected to the users`
        : `Do you want to delete the selected ${user.firstName} ${user.lastName}?`;
      if (await ConfirmDialog(msg, 'Confirm action', 'Delete', 'Cancel')) {
        this.adminUserService.deleteUser(user.id);
        this.initGrid();
      }
      isAdmin = false;
    }
  }

  activate(user) {
    let isAdmin;
    user.roles.forEach((element) => {
      if (element === 'ROLE_ADMIN') {
        isAdmin = true;
      }
    });
    user.activeInProgress = true;
    if (!isAdmin || (isAdmin && !user.active)) {
      this.adminUserService
        .activeDeactiveUser({ active: !user.active }, user.id)
        .then((val) => {
          // let activeUser = this.resultsPageGrid.gridView.data.find(u => u.id === user.id);
          setTimeout(() => {
            user.active = !user.active;
            user.blocked = val.blocked;
            user.activeInProgress = false;
          }, 2000);
        })
        .catch(() => {
          user.activeInProgress = false;
        });
    } else {
      AlertDialog(`${user.firstName} ${user.lastName} is an Administrator and cannot be deactivated!`, 'Invalid action', 'Ok');
      isAdmin = false;
    }
  }

  changeCategory(category) {
    this.category = category;
  }

  // rowCallback({ dataItem, index }) {
  //   if (dataItem.active) {
  //     return { 'active-row': true };
  //   } else {
  //     return { 'inactive-row': true };
  //   }
  // }
}
